if (!customElements.get('foolery-color-preview')) {
  customElements.define('foolery-color-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const select = this.querySelector('[data-foolery-select]');
      const form = this.querySelector('[data-foolery-preview-form]');
      if (!select) return;
      const update = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const media = [...this.querySelectorAll('[data-foolery-media]')];
        const selected = media.find(item => item.dataset.fooleryMedia === option.dataset.mediaId) || media[0];
        media.forEach(item => {
          item.hidden = item !== selected;
          if (item.hidden) item.querySelectorAll('video').forEach(video => video.pause());
        });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url.toString());
      };
      select.addEventListener('change', update);
      form?.addEventListener('submit', event => { event.preventDefault(); update(); });
    }
  });
}
